/** Normalizes a menu item's raw routerLink for navigation — shared by SideBarComponent
 *  (sidebar clicks) and GlobalSearchComponent (Quick Search "Go to page" results) so the
 *  one real special-case here (the /new-tallysheet blank-form redirect) can never drift
 *  between the two copies. See SideBarComponent.navigateMenuItem()'s original comment for why
 *  /new-tallysheet needs its own route from /new-tallysheet?transportId=... */
export function normalizeMenuRouterLink(routerLink: any): string | null {
  let link = typeof routerLink === 'string'
    ? (routerLink.startsWith('/') ? routerLink : `/${routerLink}`)
    : routerLink;
  if (link === '/new-tallysheet') link = '/new-tallysheet/new';
  return typeof link === 'string' ? link : null;
}
